import { useNavigate } from 'react-router-dom';
import { T, RADIUS, SHADOW } from '@/lib/tokens';
import logoOnWhite from '@/assets/logo-on-white.svg';
import posthog from '@/lib/posthog';

const valueProps = [
  {
    icon: '📦',
    title: 'Share items with your group',
    description: 'List tools, books, board games and more for your circle to borrow.',
  },
  {
    icon: '👀',
    title: 'Track who has what',
    description: 'Always know where your items are and when they are coming back.',
  },
  {
    icon: '🤝',
    title: 'Get things back on time',
    description: 'Set due dates and get reminders so nothing goes missing.',
  },
];

export default function OnboardingWelcome() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: T.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src={logoOnWhite}
            alt="Share Shack"
            style={{ width: 48, height: 48, display: 'block', margin: '0 auto 8px' }}
          />
          <div style={{ fontSize: 22, fontWeight: 700, color: T.text }}>Share Shack</div>
          <div style={{ fontSize: 14, color: T.textSec, marginTop: 4 }}>
            Borrow and lend with people you trust
          </div>
        </div>

        {/* Value props */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 32 }}>
          {valueProps.map((vp) => (
            <div
              key={vp.title}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 14,
                padding: '14px 16px',
                background: T.surface,
                border: `1px solid ${T.border}`,
                borderRadius: RADIUS.lg,
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: RADIUS.md,
                  background: T.accentSoft,
                  border: `1px solid ${T.accentBorder}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 20,
                  flexShrink: 0,
                }}
              >
                {vp.icon}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 2 }}>
                  {vp.title}
                </div>
                <div style={{ fontSize: 13, color: T.textSec, lineHeight: 1.5 }}>
                  {vp.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          onClick={() => {
            posthog.capture('onboarding_started');
            navigate('/onboarding/create-group');
          }}
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: RADIUS.md,
            background: T.accent,
            color: T.white,
            border: 'none',
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit',
            boxShadow: SHADOW.btn.accent,
          }}
        >
          Get Started
        </button>
      </div>
    </div>
  );
}
